import { useContext, useEffect } from 'react'
import FormInput from '../../formComponents/FormInput'
import FormButton from '../../formComponents/FormButton';
import { useNavigate } from 'react-router-dom';
import { SubscriptionContext } from '../../../../contextApi/SubscriptionContext';
import { AppContext } from '../../../../contextApi/ContextApi';

export default function UserOwnerForm() {
  const { getTodayDate } = useContext(AppContext);
  const { problem, setProgressState, setOwnerName, setOwnerEmail, setPassword, setRePassword, setOwnerPhone, handleCreateUser } = useContext(SubscriptionContext);
  useEffect(()=>{setProgressState(1)},[])
  const nav = useNavigate();

  return (
    <div className='userOwnerForm'>
        <FormInput id={"ownerName"} label={"שם מלא :"} type={"text"} placeholder={"לדוגמא: ישראל ישראלי"} setText={setOwnerName} hasButton={false} hasInfo={true} infoContent={"השם חייב להכיל שם פרטי ושם משפחה עם רווח ביניהם."}/>
        <FormInput id={"ownerEmail"} label={"אימייל :"} type={"email"} placeholder={"לדוגמא: israel.israeli@gmail.com"} setText={setOwnerEmail} hasButton={false} hasInfo={true} infoContent={"אנא הזן מייל תקין ופעיל"}/>
        <FormInput id={"ownerPassword"} label={"סיסמא :"} type={"password"} placeholder={"לדוגמא: P@ssword123"} setText={setPassword} hasButton={false} hasInfo={true} infoContent={"הסיסמא צריכה להיות בעלת 8-25 תווים,\nעליה להכיל ספרות, תווים באנגלית בלבד, וסימנים מיוחדים,\nעל הסיסמא להכיל לפחות תו מיוחד אחד, ולהתחיל באות גדולה באנגלית."}/>
        <FormInput id={"ownerRePassword"} label={"אימות סיסמא :"} type={"password"} placeholder={"נא לחזור על הסיסמא שהזנת לצורך אימות"} setText={setRePassword} hasButton={false} hasInfo={true} infoContent={"על הסיסמא החוזרת להיות תואמת במדוייק לסיסמא המקורית"}/>
        <FormInput id={"ownerPhone"} label={"מס' פלאפון נייד :"} type={"tel"} placeholder={"לדוגמא: 0501234567"} setText={setOwnerPhone} hasButton={false} hasInfo={true} infoContent={"אנא הכנס מס' נייד בעל 10 ספרות"}/>
        <div className='userOwnerForm_problem'>
          <p>{problem}</p>
          {problem === "סיסמא לא תקינה" ? <div className='userOwnerForm_invalidPasswordAlert' dir='rtl'>
            <p>{"הסיסמא חייבת להיות מהפורמט הבא:"}</p>  
            <p>{"• אותיות - באנגלית בלבד"}</p>  
            <p>{"• מתחילה באות גדולה"}</p>  
            <p>{"• על הסיסמא להכיל - [a-z/A-Z/0-9]"}</p>  
            <p>{"• באורך של כ- 8-24 תווים"}</p>  
            <p>{"• מכילה לפחות תו אחד מיוחד - [!@#$%^&*]"}</p>  
          </div> :
          problem==="הפרטים שהוזנו כבר רשומים במערכת"||problem==="המייל שהוזן כבר רשום במערכת"||problem==="מספר הפלאפון שהוזן כבר רשום במערכת" ? <p>
            להתחברות לחץ כאן - <a href="/webingo/signin">התחבר</a>
          </p> : null}
        </div>
        <FormButton text={"המשך"} action={()=>{handleCreateUser(nav, getTodayDate)}}/>
    </div>
  )
}
